import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { goToPage } from 'actions/customForm/addOrEdit'
import './Sections/form-finder.css'
import Button from 'components/theme/Button'
import { deleteSection } from 'actions/customForm/addOrEdit'
import { Remove } from '@material-ui/icons'
import { withStyles } from '@material-ui/core'

const styles = (theme) => ({
	button: {
		position: 'absolute',
		left: 0,
		bottom: -43,
		[theme.breakpoints.down('sm')]: {
			left: -28,
			transform: 'none',
			bottom: -66,
			width: 143,
		},
	},
})

class PageButtons extends Component {
	render() {
		const { pagebreaks, pageSelected, goToPage, deleteSection, classes } =
			this.props

		return (
			Boolean(pagebreaks.length) && (
				<>
					<div className="reach_pages">
						{pageSelected !== 0 && (
							<button
								onClick={() => goToPage('prev')}
								type="button"
								className="reach_pagebutton prevlink"
							>
								{'<'}
							</button>
						)}
						{pagebreaks.length < 5 ? (
							pagebreaks.map((pagebreak, idx) => (
								<button
									key={`custom-form-page-button-${idx}`}
									onClick={() => goToPage(idx)}
									type="button"
									className="reach_pagebutton"
								>
									{idx + 1}
								</button>
							))
						) : (
							<select
								style={{ borderRadius: 25, fontSize: 16, padding: 12 }}
								value={pageSelected}
								onChange={(e) => goToPage(parseInt(e?.target?.value))}
							>
								{pagebreaks.map((pagebreak, idx) => (
									<option
										key={`custom-form-page-option-${idx}`}
										value={idx}
										// onClick={() => goToPage(idx)}
									>
										Page {idx + 1}
									</option>
								))}
								<option
									key={`custom-form-page-option-${pagebreaks.length}`}
									value={pagebreaks.length}
									// onClick={() => goToPage(pagebreaks.length)}
								>
									Page {pagebreaks.length + 1}
								</option>
							</select>
						)}
						{pagebreaks.length < 5 && (
							<button
								onClick={() => goToPage(pagebreaks.length)}
								type="button"
								className="reach_pagebutton"
							>
								{pagebreaks.length + 1}
							</button>
						)}
						{pageSelected !== pagebreaks.length && (
							<button
								onClick={() => goToPage('next')}
								type="button"
								className="reach_pagebutton nextlink"
							>
								{'>'}
							</button>
						)}
					</div>
					{pageSelected !== pagebreaks.length && (
						<Button
							variant="outlined"
							className={classes.button}
							onClick={() => deleteSection(pagebreaks[pageSelected].id)}
						>
							<Remove style={{ marginRight: 5 }} />
							Remove pagebreak
						</Button>
					)}
				</>
			)
		)
	}
}

export default connect(
	(state) => ({
		pagebreaks: state.customForm.addOrEdit.form.sections
			.map((id, idx) => ({
				...state.customForm.addOrEdit.sectionsByID[id],
				idx,
			}))
			.filter((el) => el?.type === 'pagebreak'),
		pageSelected: state.customForm.addOrEdit.pageSelected,
	}),
	(dispatch) => bindActionCreators({ goToPage, deleteSection }, dispatch),
)(withStyles(styles)(PageButtons))
